import * as React from 'react';
import {
  AI_ALERTS_SENSITIVITY_CONTROL_TITLE,
  AI_ALERTS_SENSITIVITY_PRODUCT_OPTIONS,
} from '@src/utils/aiAlerts/mapping';
import { Divider } from 'antd';
import { StyledSelect, TitleWrapper, AIAlert2Info } from './styled';
import { isAppModule, PRODUCT_MODE_MAP } from '@src/utils/constants';
import AdminOnly from '@src/components/common/AdminOnly';
import { WarningOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { aiAlertFusionVsiSelector } from '@src/store/common/selectors';

const Header = ({ selectedProduct, onProductChange }) => {
  const fusionVsiEnabled = useSelector(aiAlertFusionVsiSelector);
  return (
    <>
      {isAppModule ? (
        <span>App</span>
      ) : (
        <StyledSelect
          defaultValue={selectedProduct}
          size="large"
          styles={{ popup: { root: { minWidth: '100px', padding: '10px 5px' } } }}
          options={AI_ALERTS_SENSITIVITY_PRODUCT_OPTIONS.filter((option) => option.value !== 'APP')}
          onChange={onProductChange}
        />
      )}
      <Divider type="vertical" style={{ borderColor: 'rgba(0, 0, 0, 0.8)' }} />
      <TitleWrapper>{AI_ALERTS_SENSITIVITY_CONTROL_TITLE}</TitleWrapper>
      <AdminOnly />
      {selectedProduct === PRODUCT_MODE_MAP.AI && !fusionVsiEnabled ? (
        <AIAlert2Info>
          <WarningOutlined style={{ color: '#ffa500', marginRight: 8 }} />
          {`AD AI Alerts has been deprecated since 18th Dec 2025. Please reach out to your account team in case of any questions.`}
        </AIAlert2Info>
      ) : null}
    </>
  );
};

export default Header;
